// CapturedWineTitleDocument появится после npm run codegen
import { CapturedWineTitleDocument } from 'api/hooks'
import { client } from 'utils/apollo'
import { getWineTitle } from 'components/Pages/Wine/View/_methods'

export const capturedWineNameLoader = async ({
  params,
}: {
  params: { id?: string }
}) => {
  if (!params.id) return { title: '' }

  const response = await client.query({
    query: CapturedWineTitleDocument,
    variables: { id: params.id },
  })

  const wine = response.data?.capturedWine?.product?.wine
  return { title: getWineTitle(wine) }
}
